<template>
  <el-dialog :class="{ transparent: !message }"
             custom-class="{ 'loading-dialog': true, 'closable': closable }"
             :append-to-body="true"
             title=""
             :top="'0'"
             :modal="false"
             :visible.sync="visible"
             :close-on-click-modal="closable"
             :close-on-press-escape="closable"
             :show-close="closable"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="message">{{message}}</div>
    <div>
      <infinite-progress-bar></infinite-progress-bar>
    </div>
  </el-dialog>
</template>

<script lang="js">
import InfiniteProgressBarCmp from '../progress/infinite-progress-bar.vue'

export default {
  name: 'LoadingCmp',
  components: {
    'infinite-progress-bar': InfiniteProgressBarCmp
  },
  props: {
    message: '',
    closable: {type: Boolean, default: false},
    visible: {type: Boolean, default: false}
  }
}
</script>

<style scoped>
  .el-dialog__wrapper.transparent {
    background-color: transparent;
  }

  .el-dialog__wrapper.transparent >>> .loading-dialog {
    display: none;
  }

  .el-dialog__wrapper >>> .loading-dialog {
    width: 600px;
    height: 140px;
  }

  .el-dialog__wrapper >>> .loading-dialog:not(.closable) .el-dialog__header {
    display: none;
  }

  .el-dialog__wrapper >>> .loading-dialog .el-dialog__body {
    padding: 40px;
  }

  .el-dialog__wrapper >>> .loading-dialog.closable .el-dialog__body {
    padding-top: 10px;
  }

  .el-dialog__wrapper >>> .loading-dialog .message {
    text-align: center;
    font-size: 1rem;
  }

  .el-dialog__wrapper >>> .loading-dialog .el-dialog__headerbtn {
    position: absolute;
    top: 20px;
    right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/loading/loading.vue